import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { downloadCSV } from '../services/csvExport';
import { Budget } from '../types/budget';

interface ExportCSVButtonProps {
  budget: Budget & { id: number };
  showText?: boolean;
  className?: string;
}

export const ExportCSVButton: React.FC<ExportCSVButtonProps> = ({
  budget,
  showText = false,
  className = '',
}) => {
  const { t } = useTranslation();

  const handleExport = () => {
    // Format the budget name to be filename-friendly
    const fileName = budget.name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-z0-9]+/g, '-') // Replace special chars with hyphens
      .replace(/(^-+|-+$)/g, ''); // Remove leading/trailing hyphens

    downloadCSV(budget.transactions, fileName);
  };

  const baseClasses =
    'flex items-center rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 dark:bg-green-500 dark:hover:bg-green-600';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <button
      onClick={handleExport}
      className={buttonClasses}
      title={t('budget.exportCSV')}
      data-attr="export-csv-button"
    >
      <ArrowDownTrayIcon className={`h-5 w-5 ${showText ? 'mr-2' : ''}`} />
      {showText && <span>{t('budget.exportCSV')}</span>}
    </button>
  );
};
